export enum ETypZadosti {
    REGISTRACE = 'REGISTRACE',
    AKTUALIZACE = 'AKTUALIZACE',
    KONTAKTNIUDAJE = 'KONTAKTNIUDAJE',
    PREVOD = 'PREVOD'
}
